import BaseModel from '../core/BaseModel'
export default class ProductSerialNumberDynamicFormModel extends BaseModel {
    constructor() {
        super({ 
                name: "product_serial_number_dynamic_form",
                tableName: 'core_product_serial_number_dynamic_form'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            }
        },)
    }

}